module.exports = __webpack_public_path__ + "static/media/location-icon.f6f45031.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/location-icon.svg
// module id = 252
// module chunks = 0